import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, inject, onMounted, watch } from "vue";
import {
  IOption,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  SERVICE_UID,
  ShowToastMessage,
} from "@/types";
import { Field } from "vee-validate";
import InlineSvg from "vue-inline-svg";
import useGetProtocolHost from "@/use/useGetProtocolHost";


const __default__ = {
  name: "DynamicSelect",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
  },
  name: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<IOption[]>,
  },
  datasource: {
    type: String,
  },
  nameKey: {
    type: String,
  },
  valueKey: {
    type: String,
  },
  value: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "선택하세요",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  error: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: true,
  },
  rules: {
    type: Object,
  },
  directlyEditable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:value", "onUpdatedOptions", "updateChildFieldValidity"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const inputValue = computed({
  get() {
    return props.value;
  },
  set(inputValue) {
    emit("update:value", inputValue);
  },
});

const onChangedSelect = (event: Event) => {
  const selectElement = event.target as HTMLSelectElement;
  emit("update:value", selectElement.value);
};

const parseOption = (data: any): IOption => {
  const option: IOption = {
    name: data[props.nameKey ?? ""],
    value: data[props.valueKey ?? ""],
    data,
  };
  return option;
};

const createDirectInputOption = () => {
  const directInputOption: IOption = {
    name: "직접입력",
    value: "",
  };

  return directInputOption;
};

const baseURL = `${useGetProtocolHost()}/aibos/client/api/${
  process.env.VUE_APP_API_VERSION
}/public/service/${SERVICE_UID}`;

const getOptions = async () => {
  if (!props.datasource) return;

  try {
    const response = await fetch(`${baseURL}${props.datasource}`);
    const res = await response.json();
    const options = res.data.map(parseOption);

    if (props.directlyEditable) {
      options.push(createDirectInputOption());
    }

    emit("onUpdatedOptions", options);
  } catch (error) {
    showToastMessage("선택 목록을 가져오지 못했습니다");
  }
};

const autoSelect = (options: any) => {
  // 선택지가 1개인 경우에는 자동으로 선택되도록 처리한다.
  if (options?.length === 1) {
    emit("update:value", options[0]?.value ?? "");
  }
};

watch(
  () => props.value,
  (value, preValue) => {
    if (props.directlyEditable) {
      emit("updateChildFieldValidity", true);
      return;
    }

    if (!preValue) {
      emit("updateChildFieldValidity", !!value);
    }
  }
);

watch(
  () => props.options,
  (options) => {
    if (options?.length) {
      autoSelect(options);
    }
  }
);

onMounted(() => {
  getOptions();
});

const __returned__ = { props, emit, showToastMessage, inputValue, onChangedSelect, parseOption, createDirectInputOption, baseURL, getOptions, autoSelect, get Field() { return Field }, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})